import type { BonusDetails } from "./types";

export const BONUS_CODES: BonusDetails[] = [
  {
    code: "WELCOMEBACK100",
    event: "bonus-welcome-back-completed",
    storageKey: "pending_WELCOMEBACK100",
    numGems: 100,
    successState: {
      heading: `You earned ${100} Bonus Gems!`,
      body: "Explore Immutable Play, earn more gems, and redeem rewards!",
      buttonText: "Continue to Play",
    },
    alreadyClaimedState: {
      heading: "Bonus Already Claimed!",
      body: "You've already claimed your bonus gems! Keep playing to earn more gems.",
      buttonText: "Continue to Play",
    },
    defaultState: {
      heading: "Welcome Back!",
      body: "We missed you! Log back in to claim your bonus gems.",
      buttonText: "Claim Now",
    },
  },
  {
    code: "WELCOME30",
    event: "sign-up-reward-completed",
    storageKey: "pending_WELCOME30",
    numGems: 30,
    successState: {
      heading: "Score! 30 Bonus Gems Are Yours!",
      body: "Explore Immutable Play, discover new games, and earn even more gems for awesome rewards!",
      buttonText: "Continue to Play",
    },
    alreadyClaimedState: {
      heading: "Gems Already Claimed! Keep the Good Times Rolling!",
      body: "You've already snagged your bonus gems. No worries, there are plenty more ways to earn rewards just by playing",
      buttonText: "Continue to Play",
    },
    defaultState: {
      heading: "Unlock 30 Gems: Your Journey Starts Now!",
      body: "Welcome to the Immutable Play! Sign up to claim your bonus 30 gems and kickstart your journey to awesome rewards.",
      buttonText: "Claim My 30 Gems",
    },
  },
  {
    code: "WELCOME50",
    event: "sign-up-reward-50-completed",
    storageKey: "pending_WELCOME50",
    numGems: 50,
    successState: {
      heading: "Score! 50 Bonus Gems Are Yours!",
      body: "Explore Immutable Play, discover new games, and earn even more gems for awesome rewards!",
      buttonText: "Continue to Play",
    },
    alreadyClaimedState: {
      heading: "Gems Already Claimed! Keep the Good Times Rolling!",
      body: "You've already snagged your bonus gems. No worries, there are plenty more ways to earn rewards just by playing",
      buttonText: "Continue to Play",
    },
    defaultState: {
      heading: "Your 50 Bonus Gems Are Waiting – Claim Them Now!",
      body: "Welcome to the Immutable Play! Sign up to claim your bonus 50 gems to supercharge your journey to awesome rewards.",
      buttonText: "Claim My 50 Gems",
    },
  },
  {
    code: "WELCOME100",
    event: "sign-up-reward-100-completed",
    storageKey: "pending_WELCOME100",
    numGems: 100,
    successState: {
      heading: "Epic Win! You Claimed 100 Bonus Gems!",
      body: " Unbelievable! You've just boosted your account with 100 bonus gems. Get ready to unlock some serious rewards!",
      buttonText: "Continue to Play",
    },
    alreadyClaimedState: {
      heading: "Gems Already Claimed! Keep the Good Times Rolling!",
      body: "You've already snagged your bonus gems. No worries, there are plenty more ways to earn rewards just by playing",
      buttonText: "Continue to Play",
    },
    defaultState: {
      heading: "Get 100 FREE Gems Before They're Gone!",
      body: "Welcome to the Immutable Play! This is your moment! Bag an incredible 100 bonus gems just for signing up. Don't let it slip away!",
      buttonText: "Claim My 100 Gems",
    },
  },
  {
    code: "WELCOME200",
    event: "sign-up-reward-200-completed",
    storageKey: "pending_WELCOME200",
    numGems: 200,
    successState: {
      heading: "Epic Win! You Claimed 200 Bonus Gems!",
      body: " Unbelievable! You've just boosted your account with 200 bonus gems. Get ready to unlock some serious rewards!",
      buttonText: "Continue to Play",
    },
    alreadyClaimedState: {
      heading: "Gems Already Claimed! Keep the Good Times Rolling!",
      body: "You've already snagged your bonus gems. No worries, there are plenty more ways to earn rewards just by playing",
      buttonText: "Continue to Play",
    },
    defaultState: {
      heading: "Get 200 FREE Gems Before They're Gone!",
      body: "Welcome to the Immutable Play! This is your moment! Bag an incredible 200 bonus gems just for signing up. Don't let it slip away!",
      buttonText: "Claim My 200 Gems",
    },
  },
];
